import { RecentEntities } from "@/jenesys-types/data/crud";
import { PreferenceName } from "@/jenesys-types/data/preferences";

enum LSKeys {
  JackRecentEntities = "JACK_RECENT_ENTITIES",
  Preferences = "JACK_PREFERENCES"
}

export const getRecentEntities = (keySuffix: string): RecentEntities | null => {
  const value = localStorage.getItem(
    `${LSKeys.JackRecentEntities}:${keySuffix}`
  );
  return value && JSON.parse(value);
};

export const setRecentEntities = (
  keySuffix: string,
  recentlyVisited: RecentEntities
): void =>
  localStorage.setItem(
    `${LSKeys.JackRecentEntities}:${keySuffix}`,
    JSON.stringify(recentlyVisited)
  );

const getPreferences = (): Record<string, any> => {
  const stored = localStorage.getItem(LSKeys.Preferences);
  return stored ? JSON.parse(stored) : {};
};

export const getPreference = (name: PreferenceName): any =>
  getPreferences()[name];

export const setPreference = (name: PreferenceName, value: any) => {
  const preferences = {
    ...getPreferences(),
    [name]: value
  };
  localStorage.setItem(LSKeys.Preferences, JSON.stringify(preferences));
};
